export default {
    state: {
        createRequirement:{
            AcntManager:'',
            AccountManagerName:'',
            Client:'',
            ClientContact:'',
            EndClient:'',
            Location:'',
            ZipCode:'',
            Address:'',
            RequirementId:'',            
            JobTitle:'',
            StartDate:'',
            Duration:'',
            OpenPositions:'1',
            MinExperience:'',
            MaxExperience:'',
            MinimumProjects:'',
            TaxTerms:["CorpToCorp"],
            NoPreference:true,
            WorkPermit:'',
            EducationQual:'',
            Sponsorship:true,
            JobDescription:'',
            KeySkills:[],
            TechCategory:'',
            TechSubCategory:'',
            TechCategoryObj:'',
            TechSubCategoryObj:'',
            ClientContactObj:'',
            ClientObj:'',
            JobId:''
        },
    },

    mutations: { // https://vuex.vuejs.org/en/mutations.html
        updateRequirementsField(state, p) {
            Vue.set(state.createRequirement, p.field, p.value)
        },
        updateSelectedJob(state, selectedjob){
            state.selectedJob = selectedjob;
        },      
    },
    getters: { // https://vuex.vuejs.org/en/getters.html
        getRequirementsField(state) {
            return (field) => { return state.createRequirement[field] }
        },
        getSelectedJob(state){
            return state.selectedJob;
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/Profile/Project/index.js